module.exports = __webpack_public_path__ + "static/media/home-contracting-3.9747a2f4.jpg";